import { render, staticRenderFns } from "./EmrReportBTR.vue?vue&type=template&id=3701f782&"
import script from "./EmrReportBTR.vue?vue&type=script&lang=js&"
export * from "./EmrReportBTR.vue?vue&type=script&lang=js&"
import style0 from "./EmrReportBTR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports